(function () {
"use strict";
var $ = function (id) { return document.getElementById(id); };
var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
var EN = (document.documentElement.lang || "es").slice(0, 2) === "en";
var LOC = EN ? "en-US" : "es-CO";
var nf = new Intl.NumberFormat(LOC, { maximumFractionDigits: 0 });
var nf1 = new Intl.NumberFormat(LOC, { maximumFractionDigits: 1 });
var nf2 = new Intl.NumberFormat(LOC, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
var RM = false; // el movimiento es parte de la marca: no depende de ajustes del teléfono
var T = EN ? {
years: " years", goals: ["lose fat", "maintain", "build muscle"],
imc: ["Underweight", "Normal weight", "Overweight", "Obesity"],
ratioOk: "Below 0.5: the reference health guidelines use for lower risk linked to abdominal fat.",
ratioHi: "0.5 or higher: health guidelines suggest paying attention to abdominal fat. A professional can guide you.",
q: [
{ k: "goal", q: "What is your main goal?", o: ["Lose fat", "Build muscle", "Recompose my body", "Improve my habits"] },
{ k: "exp", q: "How much training experience do you have?", o: ["Just starting", "Less than 1 year", "1 to 3 years", "More than 3 years"] },
{ k: "days", q: "How many days a week can you train?", o: ["2 days", "3 days", "4 days", "5 days or more"] },
{ k: "where", q: "Where will you train?", o: ["Gym", "Home", "Outdoors", "Mixed"] }
],
focus: ["Build the base: technique, habits and a routine you can sustain.", "Organize what you already do and create clear progression.", "Tune progression and nutrition to your goal.", "Refine the details: progression, body composition and full autonomy."],
focusNone: "We define it together in the assessment.",
steps: ["Question 1 of 4", "Question 2 of 4", "Question 3 of 4", "Question 4 of 4", "Last step", "Done"],
errFields: "Check the highlighted fields: we need your name, a valid email and your WhatsApp.",
errConsent: "To send your application, authorize the processing of your data.",
errSend: "We couldn't send your application. Check your connection and try again, or DM us SIX on Instagram.",
sending: "Sending…", send: "Send application"
} : {
years: " años", goals: ["perder grasa", "mantener", "ganar músculo"],
imc: ["Bajo peso", "Peso normal", "Sobrepeso", "Obesidad"],
ratioOk: "Por debajo de 0,5: la referencia que usan guías de salud para un riesgo menor asociado a la grasa abdominal.",
ratioHi: "En 0,5 o más: según guías de salud, conviene prestar atención a la grasa abdominal. Un profesional puede orientarte.",
q: [
{ k: "goal", q: "¿Cuál es tu objetivo principal?", o: ["Perder grasa", "Ganar músculo", "Recomponer mi físico", "Mejorar mis hábitos"] },
{ k: "exp", q: "¿Cuánta experiencia tienes entrenando?", o: ["Estoy empezando", "Menos de 1 año", "De 1 a 3 años", "Más de 3 años"] },
{ k: "days", q: "¿Cuántos días por semana puedes entrenar?", o: ["2 días", "3 días", "4 días", "5 días o más"] },
{ k: "where", q: "¿Dónde vas a entrenar?", o: ["Gimnasio", "Casa", "Al aire libre", "Combinado"] }
],
focus: ["Construir la base: técnica, hábitos y una rutina que puedas sostener.", "Ordenar lo que ya haces y crear una progresión clara.", "Ajustar progresión y nutrición a tu objetivo.", "Afinar detalles: progresión, composición corporal y autonomía total."],
focusNone: "Lo definimos juntos en la evaluación.",
steps: ["Pregunta 1 de 4", "Pregunta 2 de 4", "Pregunta 3 de 4", "Pregunta 4 de 4", "Último paso", "Listo"],
errFields: "Revisa los campos marcados: necesitamos tu nombre, un correo válido y tu WhatsApp.",
errConsent: "Para enviar tu aplicación, autoriza el tratamiento de tus datos.",
errSend: "No pudimos enviar tu aplicación. Revisa tu conexión e inténtalo de nuevo, o escríbenos SIX por DM en Instagram.",
sending: "Enviando…", send: "Enviar aplicación"
};
var KEY = "sp_calc_v1";
function load() { try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch (e) { return null; } }
function save(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
function fill(el) { el.style.setProperty("--p", ((el.value - el.min) / (el.max - el.min) * 100) + "%"); }
function swap(el) { if (!el) return; el.classList.remove("swap"); void el.offsetWidth; el.classList.add("swap"); }
function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
$$("form.ctl").forEach(function (f) { f.addEventListener("submit", function (e) { e.preventDefault(); }); });
function tabs(container, onSelect, attr) {
if (!container) return function () {};
attr = attr || "aria-selected";
var btns = $$("button", container);
function select(i, focus) {
btns.forEach(function (b, j) { b.setAttribute(attr, j === i); if (attr === "aria-selected") b.tabIndex = j === i ? 0 : -1; });
if (focus) btns[i].focus();
onSelect(i);
}
btns.forEach(function (b, i) { b.addEventListener("click", function () { select(i); }); });
return select;
}
var subs = [], ticking = false;
function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; subs.forEach(function (f) { f(); }); }); } }
window.addEventListener("scroll", onScroll, { passive: true });
window.addEventListener("resize", onScroll);
window.addEventListener("touchmove", onScroll, { passive: true });
var lastY = -1, loops = [];
(function tick(now) {
var y = window.pageYOffset || document.documentElement.scrollTop || 0;
if (y !== lastY) { lastY = y; subs.forEach(function (f) { f(); }); }
loops.forEach(function (f) { f(now); });
requestAnimationFrame(tick);
})(performance.now());
function progress(el) {
var r = el.getBoundingClientRect(), h = r.height - window.innerHeight;
return h <= 0 ? (r.top <= 0 ? 1 : 0) : clamp(-r.top / h, 0, 1);
}
(function () {
var h = document.querySelector(".h4"); if (!h) return;
var last = 0;
subs.push(function () {
var y = window.scrollY;
h.classList.toggle("solid", y > 40);
var menuOpen = $("mnav") && !$("mnav").hidden;
h.classList.toggle("hide", y > 640 && y > last + 4 && !menuOpen);
if (y < last - 4) h.classList.remove("hide");
last = y;
});
onScroll();
})();
(function () {
var mb = $("menuBtn"), mn = $("mnav"); if (!mb || !mn) return;
function set(open) { mb.setAttribute("aria-expanded", open); mn.hidden = !open; document.querySelector(".h4").classList.toggle("solid", open || window.scrollY > 40); }
mb.addEventListener("click", function () { set(mn.hidden); });
mn.addEventListener("click", function (e) { if (e.target.closest("a")) set(false); });
document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !mn.hidden) { set(false); mb.focus(); } });
})();
(function () {
var hero = $("hero4"); if (!hero || !window.SPBarbell) return;
var cv = hero.querySelector("canvas"), st2 = hero.querySelector(".st2"), st3 = hero.querySelector(".st3"), st1 = hero.querySelector(".st1");
var meter = hero.querySelector(".meter"), marks = $$(".prog span", hero);
var bb = new SPBarbell(cv, {
segments: window.innerWidth < 700 ? 44 : 64,
labels: $$(".plabel", hero),
layout: function (W, H, p) {
if (W < 820) return { cx: .5, cy: .4, scale: 1.05 - .37 * clamp((p - .12) / .25, 0, 1) };
return { cx: .62, cy: .47, scale: 1 };
}
});
function vis(el, a) { el.style.opacity = a; el.style.visibility = a > .01 ? "visible" : "hidden"; el.style.transform = "translateY(" + ((1 - a) * 24) + "px)"; }
function win(p, a, b, f) { return clamp(Math.min((p - a) / f, (b - p) / f), 0, 1); }
var lastP = -1, onScreen = true, lastW = 0, lastH = 0;
function text(p) {
st1.style.opacity = clamp(1 - p / .22, 0, 1);
st1.style.transform = "translateY(" + (-p * 120) + "px)";
st1.style.visibility = p > .23 ? "hidden" : "visible";
vis(st2, clamp((p - .42) / .12, 0, 1));
if (st3) vis(st3, 0);
if (meter) { meter.style.opacity = clamp(1 - p / .2, 0, 1) * .9; meter.style.transform = "translate(-50%,-50%) scale(" + (1 + p * .6) + ")"; }
var stage = p < .42 ? 0 : 1;
marks.forEach(function (m, i) { m.classList.toggle("on", i === stage); });
}
loops.push(function (now) {
if (!onScreen) return;
var p = progress(hero);
if (Math.abs(p - lastP) > .0005) { lastP = p; text(p); }
bb.draw(p, now / 1000);
});
if ("IntersectionObserver" in window) new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; }).observe(hero);
function ro() {
var w = cv.clientWidth, h = cv.clientHeight;
if (w === lastW && Math.abs(h - lastH) < 2) return; // la barra de direcciones del móvil no reinicia el lienzo
lastW = w; lastH = h; bb.resize();
}
window.addEventListener("resize", ro);
window.addEventListener("orientationchange", function () { setTimeout(ro, 250); });
ro(); text(progress(hero));
})();
(function () {
var lit = $$(".lit"); if (!lit.length) return;
lit.forEach(function (p) {
var html = p.innerHTML.trim().split(/(\s+)/).map(function (w) {
if (/^\s+$/.test(w)) return w;
var acc = /^\*.*\*[.,]?$/.test(w);
w = w.replace(/\*/g, "");
return '<span class="wd' + (acc ? " acc" : "") + '">' + w + "</span>";
}).join("");
p.innerHTML = html;
var words = $$(".wd", p);
subs.push(function () {
var r = p.getBoundingClientRect(), vh = window.innerHeight;
var t = clamp((vh * .85 - r.top) / (r.height + vh * .45), 0, 1);
var n = Math.round(t * words.length);
words.forEach(function (w, i) { w.classList.toggle("on", RM || i < n); });
});
});
onScroll();
})();
(function () {
var panels = $$(".panel"), links = $$(".idx a"); if (!panels.length || !links.length || !("IntersectionObserver" in window)) return;
var io = new IntersectionObserver(function (es) {
es.forEach(function (e) { if (e.isIntersecting) { var i = panels.indexOf(e.target); links.forEach(function (l, j) { l.classList.toggle("on", i === j); }); } });
}, { rootMargin: "-45% 0px -45% 0px" });
panels.forEach(function (p) { io.observe(p); });
})();
(function () {
var items = $$(".plist4 li"), cards = $$(".pcard4"); if (!items.length) return;
function set(i) {
items.forEach(function (li, j) { li.classList.toggle("on", i === j); });
cards.forEach(function (c, j) { c.classList.toggle("on", i === j); });
}
subs.push(function () {
var mid = window.innerHeight * .5, best = 0, bd = 1e9;
items.forEach(function (li, i) { var r = li.getBoundingClientRect(), d = Math.abs(r.top + r.height / 2 - mid); if (d < bd) { bd = d; best = i; } });
set(best);
});
items.forEach(function (li, i) { li.addEventListener("mouseenter", function () { set(i); }); });
set(0); onScroll();
})();
(function () {
var els = $$("[data-rv]"); if (!els.length) return;
if (!("IntersectionObserver" in window) || RM) { els.forEach(function (e) { e.classList.add("on"); }); return; }
var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("on"); io.unobserve(e.target); } }); }, { rootMargin: "0px 0px -10% 0px" });
els.forEach(function (e) { io.observe(e); });
})();
(function () {
if (RM) return;
var imgs = $$(".fig4 img, .fig4 video"); if (!imgs.length) return;
subs.push(function () {
var vh = window.innerHeight;
imgs.forEach(function (im) {
var r = im.parentNode.getBoundingClientRect();
if (r.bottom < -50 || r.top > vh + 50 || !r.height) return;
var t = ((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2);
im.style.transform = "translate3d(0," + (clamp(t, -1, 1) * -6).toFixed(2) + "%,0)";
});
});
onScroll();
})();
(function () {
if (!$("bmrForm")) return;
var sex = "f", e = $("b-edad"), w = $("b-peso"), h = $("b-talla"), act = $("b-act");
var prev = load();
if (prev && prev.inputs) { sex = prev.inputs.sex || sex; e.value = prev.inputs.a || e.value; w.value = prev.inputs.w || w.value; h.value = prev.inputs.h || h.value; act.value = prev.inputs.f || act.value; }
function calc() {
var a = +e.value, kg = +w.value, cm = +h.value, f = +act.value;
var bmr = 10 * kg + 6.25 * cm - 5 * a + (sex === "m" ? 5 : -161);
var tdee = bmr * f, pa = Math.round(bmr / tdee * 100);
$("b-edadOut").textContent = a + T.years;
$("b-pesoOut").textContent = nf1.format(kg) + " kg";
$("b-tallaOut").textContent = cm + " cm";
$("bmr").textContent = nf.format(Math.round(bmr / 10) * 10);
$("tdee").textContent = nf.format(Math.round(tdee / 10) * 10);
$("splitA").style.width = pa + "%"; $("splitB").style.width = (100 - pa) + "%";
$("pctA").textContent = pa + " %"; $("pctB").textContent = (100 - pa) + " %";
[e, w, h].forEach(fill);
save({ bmr: bmr, tdee: tdee, w: kg, h: cm, inputs: { sex: sex, a: a, w: kg, h: cm, f: f } });
}
[e, w, h].forEach(function (el) { el.addEventListener("input", calc); });
act.addEventListener("change", calc);
var select = tabs($("sexSeg"), function (i) { sex = i === 0 ? "m" : "f"; calc(); }, "aria-pressed");
select(sex === "m" ? 0 : 1);
})();
(function () {
if (!$("m-kcal")) return;
var kcal = $("m-kcal"), peso = $("m-peso"), goal = 0, synced = true, S = load();
var F = [.85, 1, 1.10];
function calc() {
var base = +kcal.value || 0, kg = +peso.value, target = base * F[goal], floored = false;
if (S && S.bmr && synced && target < S.bmr) { target = S.bmr; floored = true; }
var pG = 1.6 * kg, fG = target * .25 / 9, cG = Math.max(0, (target - pG * 4 - fG * 9) / 4);
var pK = pG * 4, fK = fG * 9, cK = cG * 4, tot = pK + fK + cK || 1;
$("m-pesoOut").textContent = nf1.format(kg) + " kg";
$("m-target").textContent = nf.format(Math.round(target / 10) * 10);
$("m-goalTxt").textContent = T.goals[goal];
[["p", pG, pK], ["c", cG, cK], ["f", fG, fK]].forEach(function (r) {
var pct = Math.round(r[2] / tot * 100);
$("m-" + r[0] + "g").textContent = nf.format(Math.round(r[1]));
$("m-" + r[0] + "k").textContent = nf.format(Math.round(r[2] / 10) * 10) + " kcal · " + pct + " %";
$("m-" + r[0] + "bar").style.width = pct + "%";
});
$("m-floor").hidden = !floored; $("m-sync").hidden = synced || !S;
$("m-syncNote").hidden = !(synced && S); $("m-noData").hidden = !!S;
fill(peso);
}
function pull() { if (S && synced) { kcal.value = Math.round(S.tdee / 10) * 10; peso.value = S.w; } calc(); }
kcal.addEventListener("input", function () { synced = false; calc(); });
peso.addEventListener("input", function () { synced = false; calc(); });
$("m-sync").addEventListener("click", function () { synced = true; S = load(); pull(); });
tabs($("goalSeg"), function (i) { goal = i; calc(); }, "aria-pressed");
pull();
})();
(function () {
var peso = $("peso"); if (!peso) return;
var S = load(); if (S && S.w) peso.value = Math.round(S.w);
function calc() { var kg = +peso.value, g = kg * 1.6; $("pesoOut").textContent = kg + " kg"; $("prot").textContent = Math.round(g); $("meal").textContent = Math.round(g / 4); fill(peso); }
peso.addEventListener("input", calc); calc();
})();
(function () {
if (!$("i-peso")) return;
var w = $("i-peso"), h = $("i-talla"), c = $("i-cint"), S = load();
if (S) { w.value = S.w; h.value = S.h; }
function calc() {
var kg = +w.value, cm = +h.value, ci = +c.value, m = cm / 100, v = kg / (m * m), r = ci / cm;
$("i-pesoOut").textContent = nf1.format(kg) + " kg"; $("i-tallaOut").textContent = cm + " cm"; $("i-cintOut").textContent = ci + " cm";
$("i-val").textContent = nf1.format(Math.round(v * 10) / 10);
$("i-cat").textContent = T.imc[v < 18.5 ? 0 : v < 25 ? 1 : v < 30 ? 2 : 3];
$("i-mark").style.left = clamp((v - 15) / 25 * 100, 0, 100) + "%";
$("i-ratio").textContent = nf2.format(r);
$("i-ratioTxt").textContent = r < .5 ? T.ratioOk : T.ratioHi;
[w, h, c].forEach(fill);
}
[w, h, c].forEach(function (el) { el.addEventListener("input", calc); });
calc();
})();
(function () {
if (!$("wiz")) return;
var st = { step: 0, a: {} }, opts = $("wOpts"), sending = false;
function render(moveFocus) {
var s = st.step;
$("wStep").textContent = T.steps[s];
$("wTrack").style.transform = "scaleX(" + (s / 5) + ")";
$("wBack").hidden = !(s > 0 && s < 5);
$("wQ").hidden = s > 3; $("wForm").hidden = s !== 4; $("wDone").hidden = s !== 5;
["goal", "exp", "days", "where"].forEach(function (k) { $("s-" + k).textContent = st.a[k] || "—"; });
if (s <= 3) {
var q = T.q[s];
$("wQuestion").textContent = q.q;
opts.textContent = "";
q.o.forEach(function (label) {
var b = document.createElement("button");
b.type = "button"; b.className = "opt"; b.textContent = label;
b.setAttribute("aria-pressed", st.a[q.k] === label);
b.addEventListener("click", function () { st.a[q.k] = label; st.step = Math.min(s + 1, 4); render(true); });
opts.appendChild(b);
});
swap($("wQ"));
if (moveFocus) (opts.querySelector('[aria-pressed="true"]') || opts.firstChild).focus({ preventScroll: true });
} else if (s === 4) {
var ix = T.q[1].o.indexOf(st.a.exp);
$("wFocus").textContent = ix >= 0 ? T.focus[ix] : T.focusNone;
swap($("wForm"));
if (moveFocus) $("f-nombre").focus({ preventScroll: true });
} else { swap($("wDone")); $("wDoneTitle").focus({ preventScroll: true }); }
}
$("wBack").addEventListener("click", function () { st.step = Math.max(st.step - 1, 0); render(true); });
$("wRestart").addEventListener("click", function () { st = { step: 0, a: {} }; $("wForm").reset(); render(true); });
$("wForm").addEventListener("submit", function (e) {
e.preventDefault(); if (sending) return;
var f = e.target, err = $("wErr"), bad = null, btn = f.querySelector('button[type="submit"]');
["f-nombre", "f-correo", "f-wa"].forEach(function (id) {
var el = $(id), v = el.value.trim();
var ok = v !== "" && (el.type !== "email" || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) && (el.type !== "tel" || v.replace(/\D/g, "").length >= 7);
el.setAttribute("aria-invalid", !ok); if (!ok && !bad) bad = el;
});
if (bad) { err.textContent = T.errFields; bad.focus(); return; }
if (!$("f-ok").checked) { err.textContent = T.errConsent; $("f-ok").focus(); return; }
err.textContent = "";
$("h-goal").value = st.a.goal || ""; $("h-exp").value = st.a.exp || ""; $("h-days").value = st.a.days || ""; $("h-where").value = st.a.where || "";
try { sessionStorage.setItem("sp_wiz", JSON.stringify(st.a)); } catch (x) {}
sending = true; btn.disabled = true; btn.textContent = T.sending;
HTMLFormElement.prototype.submit.call(f);
});
var saved = null; try { saved = JSON.parse(sessionStorage.getItem("sp_wiz")); } catch (x) {}
if ($("wPosted")) { st = { step: 5, a: saved || {} }; try { sessionStorage.removeItem("sp_wiz"); } catch (x) {} }
else if ($("wSrvErr")) { st = { step: 4, a: saved || {} }; }
render(false);
if ($("wPosted") || $("wSrvErr")) setTimeout(function () { $("aplicar").scrollIntoView(); }, 60);
})();
(function () {
var vids = $$("video.v4"); if (!vids.length) return;
var st = document.createElement("style");
st.textContent = ".fig4 video{position:absolute;inset:-8% 0;width:100%;height:116%;object-fit:cover;display:block;will-change:transform;background:#0d1a2b}" +
".end4 .bg video{inset:-6% 0;height:112%}" +
"video.v4::-webkit-media-controls,video.v4::-webkit-media-controls-start-playback-button{display:none!important;-webkit-appearance:none}";
document.head.appendChild(st);
function play(v) {
if (!v.src) { v.src = v.getAttribute("data-src"); }
var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
}
if (!("IntersectionObserver" in window)) { vids.forEach(play); return; }
var io = new IntersectionObserver(function (es) {
es.forEach(function (e) {
var v = e.target;
if (e.isIntersecting) play(v); else if (v.src && !v.paused) v.pause();
});
}, { rootMargin: "200px 0px" });
vids.forEach(function (v) { io.observe(v); });
function unlock() {
vids.forEach(function (v) {
var r = v.getBoundingClientRect();
if (r.width && r.bottom > -200 && r.top < window.innerHeight + 200) play(v);
});
}
["touchstart", "pointerdown"].forEach(function (ev) { window.addEventListener(ev, unlock, { passive: true }); });
})();
(function () {
var mcta = $("mcta"), hero = document.querySelector("[data-hero]");
if (!mcta || !hero || !("IntersectionObserver" in window)) return;
var heroIn = true, applyIn = false, apply = $("aplicar");
function upd() { mcta.classList.toggle("show", !heroIn && !applyIn); }
new IntersectionObserver(function (es) { heroIn = es[0].isIntersecting; upd(); }, { rootMargin: "0px 0px -60% 0px" }).observe(hero);
if (apply) new IntersectionObserver(function (es) { applyIn = es[0].isIntersecting; upd(); }, { rootMargin: "0px 0px -20% 0px" }).observe(apply);
})();
})();